import { render, staticRenderFns } from "./CompanyVendorComponent.vue?vue&type=template&id=404f957b&"
import script from "./CompanyVendorComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyVendorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports